// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

/**
 * Gatsby Browser Configuration
 * Client-side functionality and performance optimizations
 */

// Import GoatCounter client-side integration
require("./src/utils/goatcounter-client")

// Performance optimizations and client-side setup
exports.onClientEntry = () => {
  // Preload critical resources
  if (typeof document !== "undefined") {
    // Preload GoatCounter script for better performance
    const isProduction = process.env.NODE_ENV === "production"
    const allowLocal = process.env.GATSBY_ALLOW_LOCAL_ANALYTICS === "true"

    if (isProduction || allowLocal) {
      const link = document.createElement("link")
      link.rel = "preload"
      link.href = "//stats.mannuk.rocks/count.js"
      link.as = "script"
      link.crossOrigin = "anonymous"
      document.head.appendChild(link)
    }
  }

  // Add global error handling
  if (typeof window !== "undefined") {
    window.addEventListener("error", (event) => {
      // Log errors but don't expose sensitive information
      console.error(
        "Client-side error:",
        event.message,
        event.filename,
        event.lineno
      )
    })

    window.addEventListener("unhandledrejection", (event) => {
      console.error("Unhandled promise rejection:", event.reason)
    })
  }
}

// Route update handling for SPA navigation
exports.onRouteUpdate = ({ location, prevLocation }) => {
  // Handle GoatCounter page view tracking for client-side routing
  if (typeof window !== "undefined" && window.goatcounter) {
    // Small delay to ensure page has loaded
    setTimeout(() => {
      if (
        window.goatcounter &&
        typeof window.goatcounter.count === "function"
      ) {
        window.goatcounter.count({
          path: location.pathname + location.search,
          referrer: prevLocation ? prevLocation.href : document.referrer,
        })
      }
    }, 100)
  }
}

// Service worker integration (if needed in the future)
exports.onServiceWorkerUpdateReady = () => {
  // Handle service worker updates
  console.log("Service worker update ready")
}
